import { TReduxActions } from '../../types/redux';
import { ESpecialPromosBlocksTypes } from '../../actions';
import { ISpecialPromosBlocks } from '../../types/specialPromosBlocks';

export const defaultSpecialPromosBlocksInitialState: ISpecialPromosBlocks = {
  banks: [],
  phone: '',
  mortgageBanner: null,
};

export function specialPromosBlocksReducer(
  state: ISpecialPromosBlocks = defaultSpecialPromosBlocksInitialState,
  action: TReduxActions,
) {
  switch (action.type) {
    case ESpecialPromosBlocksTypes.ESpecialPromosBlocksRefresh:
      return {
        ...state,
        ...action.payload,
      };

    default:
      return state;
  }
}
